import { Breakpoint, Icon } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const StyledIcon = styled(Icon)`
  @media ${Breakpoint.SmallDesktop} {
    transform: rotate(45deg);
  }
`;

export const ConfirmButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
